<ng-container *transloco="let t">
  <main class="input">
    <section *ngIf="waterFlowData">
      <authority-labs-check-case
        (dataChange)="onChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [allwaysApplicable]="true"
        [inspection]="waterFlowData"
      >
        <table class="mat-table mat-elevation-z4 boundary">
          <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell" style="width: 150px"></th>
              <th class="mat-header-cell" style="width: 150px">
                {{ t('inspection.fields.waterFlow:flowRateGPM') }}
              </th>
              <th class="mat-header-cell" style="width: 150px">
                {{ t('inspection.fields.waterFlow:declaredPressurePSI') }}
              </th>
              <th class="mat-header-cell" style="width: 150px">
                {{ t('inspection.fields.waterFlow:measuredPressurePSI') }}
              </th>
              <th class="mat-header-cell" style="width: 150px">
                {{ t('inspection.fields.waterFlow:rotationSpeed') }}
              </th>
            </tr>
          </thead>
          <tbody style="text-align: right">
            <tr class="mat-row">
              <td class="mat-cell">
                {{ t('inspection.fields.waterFlow:noFlow') }}
              </td>
              <td class="mat-cell"></td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:closedTap:declaredPressure"
                    [drawableFieldTitle]="
                      t(
                        'inspection.fields.waterFlow:closedTap:declaredPressure'
                      )
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressureClosedTap.declaredPressure
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>psi</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:closedTap:measuredPressure"
                    [drawableFieldTitle]="
                      t(
                        'inspection.fields.waterFlow:closedTap:measuredPressure'
                      )
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressureClosedTap.measuredPressure
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>psi</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:closedTap:rotationSpeed"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:closedTap:rotationSpeed')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressureClosedTap.rotationSpeed
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>rpm</span>
                </mat-form-field>
              </td>
            </tr>

            <tr class="mat-row">
              <td class="mat-cell">
                {{ t('inspection.fields.waterFlow:hundredPercent') }}
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:100:flowRate"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:100:flowRate')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="waterFlowData.flowAndPressure100.flowRate"
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>gpm</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:100:declaredPressure"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:100:declaredPressure')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressure100.declaredPressure
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>psi</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:100:measuredPressure"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:100:measuredPressure')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressure100.measuredPressure
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>psi</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:100:rotationSpeed"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:100:rotationSpeed')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="waterFlowData.flowAndPressure100.rotationSpeed"
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>rpm</span>
                </mat-form-field>
              </td>
            </tr>

            <tr class="mat-row">
              <td class="mat-cell">
                {{ t('inspection.fields.waterFlow:hundredFiftyPercent') }}
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:150:flowRate"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:150:flowRate')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="waterFlowData.flowAndPressure150.flowRate"
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>gpm</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:150:declaredPressure"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:150:declaredPressure')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressure150.declaredPressure
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>psi</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:150:measuredPressure"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:150:measuredPressure')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="
                      waterFlowData.flowAndPressure150.measuredPressure
                    "
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>psi</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    name="edition"
                    min="0"
                    drawableField="waterFlow:150:rotationSpeed"
                    [drawableFieldTitle]="
                      t('inspection.fields.waterFlow:150:rotationSpeed')
                    "
                    [drawableFieldReadonly]="readonly"
                    [(ngModel)]="waterFlowData.flowAndPressure150.rotationSpeed"
                    [readonly]="readonly || printPreview"
                    (input)="onChange()"
                  />
                  <span class="prefix" matSuffix>rpm</span>
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>
      </authority-labs-check-case>
    </section>
  </main>
</ng-container>
